import React from 'react';

import { 
    Area, Title, RedStripe, BigCompaniesText, Companies, Company0Icon, Company1Icon,
    Company2Icon, Company3Icon, Company4Icon,
 } from './index.style';
const BigCompanies = ({ bigCompanies: { text } }) => (<Area>
    <Title>
        <RedStripe />
        חברות גדולות סומכות עלינו
    </Title>
    {!!text && <BigCompaniesText>{text.text}</BigCompaniesText>}
    <Companies>
        <Company0Icon />
        <Company1Icon />
        <Company2Icon />
        <Company3Icon />
        <Company4Icon />
    </Companies>
</Area>);

export default BigCompanies;